
import { updateAppConfig } from '#app'
import { defuFn } from '/home/firethewall/Projetos/projeto_OO/OO-Administrador/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "98d76214-112b-4947-bb85-cdbbd0b616e8"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
